module.exports = __webpack_public_path__ + "static/media/magnifying-glass.aa27bdf1.svg";